let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("46xqb")).then(() => parcelRequire('a8hd9'));